module.exports = __webpack_public_path__ + "img/LI107359.9363d862.png";